import { Pipe, PipeTransform } from '@angular/core';
import { ProductDetailViewModel } from '@models/api-search.models';

@Pipe({
    name: 'sortSelectedProduct',
    standalone: true
})
export class SortSelectedProductPipe implements PipeTransform {
    /**
     * Sorts products by selected product first in the list. If no selected product is given, it will return the products as is.
     * Only if the number of products is greater than or equal to numMinToSort.
     * @param products The products to sort.
     * @param selectedProduct The product number of the selected product which should be sorted first.
     * @param numMinToSort The minimum number of products to activate the sort.
     */
    transform(
        products: ProductDetailViewModel[],
        selectedProduct?: string,
        numMinToSort: number = 5
    ): ProductDetailViewModel[] {
        if (!products) {
            return [];
        }

        if (selectedProduct && products.length >= numMinToSort) {
            return products.sort((productA, productB): number => {
                if (productA.productNo === selectedProduct) {
                    return -1;
                } else if (productB.productNo === selectedProduct) {
                    return 1;
                } else {
                    return 0;
                }
            });
        }

        return products || [];
    }
}
